import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useAppDispatch } from '@/store';
import { updateUserPassword } from '@/store/thunks/userThunks';
import { Input, Button } from '@/components/ui';

const schema = Yup.object({
  password: Yup.string().required('Mot de passe obligatoire'),
});

interface UpdatePwdFormProps {
  onClose?: () => void;
  onSuccess?: () => void;
}

export default function UpdatePwdForm({ onClose, onSuccess }: UpdatePwdFormProps) {
  const dispatch = useAppDispatch();

  const formik = useFormik({
    initialValues: { password: '' },
    validationSchema: schema,
    onSubmit: async (values) => {
      const res = await dispatch(updateUserPassword(values.password));
      if (updateUserPassword.fulfilled.match(res)) {
        formik.resetForm();
        onSuccess?.();
        onClose?.();
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit} className="space-y-4">
      <Input label="Nouveau mot de passe" type="password" id="password" {...formik.getFieldProps('password')} error={formik.touched.password ? formik.errors.password : undefined} />
      <div className="flex justify-end gap-2 pt-2">
        {onClose && <Button type="button" variant="outline" onClick={onClose}>Annuler</Button>}
        <Button type="submit" loading={formik.isSubmitting}>Modifier</Button>
      </div>
    </form>
  );
}
